var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 26,
    viewBox: "0 0 66 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.977 0C33.6762 0 32.4405 0.628717 31.7034 1.71271L15.5087 24.8235C14.9667 25.5823 14.1429 25.9725 13.319 25.9725H46.7708C47.5946 25.9725 48.4184 25.5823 48.9604 24.8235L64.8733 2.10295C65.502 1.21407 64.8516 0 63.7893 0H34.977Z",
    fill: "url(#paint0_linear_0_1226)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3499 7.19771C0.265919 7.19771 -0.362789 8.41178 0.265919 9.30066L11.1491 24.8235C11.6911 25.5823 12.5149 25.9725 13.3388 25.9725H46.7688C45.945 25.9725 45.1211 25.5823 44.5792 24.8235L33.4358 8.88874C32.677 7.82642 31.463 7.17603 30.1622 7.17603H1.3499V7.19771Z",
    fill: "url(#paint1_linear_0_1226)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8665 7.19885L15.509 24.8246C14.9671 25.5834 14.1432 25.9737 13.3194 25.9737C12.4956 25.9737 11.6717 25.5834 11.1298 24.8246L0.246563 9.3018C-0.382147 8.41293 0.268242 7.19885 1.33055 7.19885H27.8665Z",
    fill: "#13D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3719 6.35437C50.3719 5.80195 50.8198 5.35412 51.3722 5.35412H57.5959C58.1483 5.35412 58.5962 5.80195 58.5962 6.35437C58.5962 6.9068 58.1483 7.35463 57.5959 7.35463H51.3722C50.8198 7.35463 50.3719 6.9068 50.3719 6.35437Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4841 2.24222C55.0365 2.24222 55.4843 2.69005 55.4843 3.24247L55.4843 9.46627C55.4843 10.0187 55.0365 10.4665 54.4841 10.4665C53.9316 10.4665 53.4838 10.0187 53.4838 9.46627V3.24247C53.4838 2.69005 53.9316 2.24222 54.4841 2.24222Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1226",
    x1: 65.1164,
    y1: 12.9819,
    x2: 13.3244,
    y2: 12.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    stopColor: "#13D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1226",
    x1: 46.7739,
    y1: 16.5748,
    x2: 0.0134569,
    y2: 16.5748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    stopColor: "#050A30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.0f5d4d0335c542e96f91c190677edc73.svg";
export { ForwardRef as ReactComponent };